import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GoalsReviewStage } from '@/features/one-on-one/goals-review/GoalsReviewStage';
import { PlatformRestriction } from '@/shared/navigation/components/PlatformRestriction';
import { useEmployeeContext } from '@/shared/contexts/EmployeeContext';
import {
  useGetEmployeeOneOnOnes,
  useGetManagerOneOnOnes,
} from '@/shared/hooks/useOneOnOne';
import { useMemo } from 'react';

export const Route = createFileRoute('/_dashboard/one-on-one/$id/goals-review')(
  {
    component: RouteComponent,
  }
);

function RouteComponent() {
  const { id } = Route.useParams();
  const employee = useEmployeeContext();
  const navigate = useNavigate();

  const { data: employeeOneOnOnes } = useGetEmployeeOneOnOnes({
    employeeId: employee._id,
  });

  const { data: managerOneOnOnes } = useGetManagerOneOnOnes({
    managerId: employee._id,
  });

  const targetEmployeeId = useMemo(() => {
    // Check if this is an employee's one-on-one or manager's
    const employeeOneOnOne = employeeOneOnOnes?.meetings?.find(
      (item) => item._id === id
    );
    const managerOneOnOne = managerOneOnOnes?.find((item) => item._id === id);

    const currentOneOnOne = employeeOneOnOne || managerOneOnOne;

    // Determine which employee's goals to fetch
    // If viewing as manager, fetch the employee's goals (not the manager's)
    return currentOneOnOne?.employeeId || employee._id;
  }, [employeeOneOnOnes, managerOneOnOnes, id, employee._id]);

  const handleComplete = () => {
    navigate({ to: `/one-on-one/${id}/summary` });
  };

  return (
    <PlatformRestriction notAllowedPlatforms={['mobile']}>
      <div className="flex min-h-screen flex-col">
        {/* Full-width gradient banner */}
        <div className="h-28 bg-gradient-to-r from-brand-gradient-start via-brand-gradient-mid to-brand-gradient-end md:h-32 rtl:bg-gradient-to-l" />

        {/* Content pulled up to overlap gradient */}
        <div className="-mt-[60px] flex flex-1 flex-col px-4 pb-10 sm:px-6 lg:px-8">
          <div className="mx-auto w-full max-w-[86rem] space-y-6">
            <GoalsReviewStage
              sessionId={id}
              employeeId={targetEmployeeId}
              onComplete={handleComplete}
            />
          </div>
        </div>
      </div>
    </PlatformRestriction>
  );
}
